import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class RequestService {

  constructor(private http: HttpClient) { }

  marginTrading(formData: any): Observable<any> {
    return this.http.post('/marginTrading', formData);
  }
  
  mtfData(clientId: any): Observable<any> {
    return this.http.get('/mtfData', { params: { clientcode: clientId } });
  }

  brokerageDetails(formData: any): Observable<any> {
    return this.http.get('/brokerageDetails', formData);
  }

  brokerageEligibleTpro(): Observable<any> {
    return this.http.get('/brokerageEligibleTpro');
  }

  changeBrokeragePlan(formData: any): Observable<any> {
    return this.http.post('/changeBrokerage', formData);
  }

  brokerageModOtp(formData: any): Observable<any> {
    return this.http.post('/brokerageModOtp', formData);
  }

  zeroBrokerageRequest(formData: any): Observable<any> {
    return this.http.post(`/zerobrokerage`, formData);
  }

  zeroBrokerageNewclientRequest(formData: any): Observable<any> {
    return this.http.post('/zeroBrokerageNewClient',formData);
  }

  brokerageEligible(): Observable<any> {
    return this.http.get('/brokerage-eligible');
  }

  brokerageLedgervalidation(): Observable<any> {
    return this.http.get('/ledger-validation');
  }

  brokerageRequest(): Observable<any> {
    return this.http.post('/brokerage-request', null); 
  }

 verifyBrokerageRequest(formData: any): Observable<any> {
   return this.http.post('/verify-brokerage-request', formData);
 }

  checkRenewalEligibility(): Observable<any> {
    return this.http.post('/check-renewal-eligibility', {});
  }

  customizeBrokerageRequest(): Observable<any> {
    return this.http.post('/customize-brokerage-otp', {});
  }

  processCustomizeBrokerageRequest(formData: any): Observable<any> {
    return this.http.post('/process-customize-brokerage-request', formData);
  }

  brokerageEligibleDetails(): Observable<any> {
    return this.http.get('/brokerage-eligible-flow-details');
  }

  brokeragefixDetails(): Observable<any> {
    return this.http.get('/fixed-brokerage-details');
  }

  fixedBrokerageOtp(params:any):Observable<any> {
    return this.http.post('/fixed-brokerage-otp', params)
  }
  submitFixedBrokerage(params:any):Observable<any> {
    return this.http.post('/submit-fixed-brokerage',params);
  }

}
